import * as React from 'react';
import './LoginMethodsInfo.scss';
import GoogleIcon from '../Icons/GoogleIcon';

export interface LoginMethodsInfoProps {
    message: string;
    icon?: React.ReactNode;
    onClick?: () => void;
}

const LoginMethodsInfo: React.FC<LoginMethodsInfoProps> = ({ message, icon, onClick }) => {
    const content = (
        <>
            {icon || <GoogleIcon width={16} height={16} />}
            {message}
        </>
    );

    if (onClick) {
        return (
            <div className="loginMethodsInfo loginMethodsInfo--clickable" onClick={onClick}>
                {content}
            </div>
        );
    }

    return (
        <div className="loginMethodsInfo">
            {content}
        </div>
    );
};

export default LoginMethodsInfo;
